import { useMutation } from "@tanstack/react-query"
import { InvitationPostBody } from "../types/types"
import { apiFetch } from "../utils/api"
import { useAuth } from "../hooks/useAuth"

export const useSignup = () => {
  const { login } = useAuth()
  return useMutation({
    mutationFn: (patientInvitationBody: InvitationPostBody) =>
      apiFetch("/filter/patients/invitation", {
        method: "PATCH",
        body: patientInvitationBody
      }),
    onError: (error) => {
      console.error("Error:", error)
    },
    onSuccess: (data, variables) => {
      login(variables.patient.email, variables.patient.password)
    }
  })
}
